import {
	closeModalTransactionAction,
	IBaseAction,
	MainUtils,
	openModalAction,
	panelType
} from '@bimser/common';
import { createGuid, createMutableAction } from '@bimser/core';
import { put, spawn, take } from 'redux-saga/effects';
import { closeFlexPanelByIdTransactionAction } from '../../../../app-main/actions';
import { ANIMATION_END_PANEL } from '../../../../app-main/actions/actionTypes';
import {
	initializePanelManagerTransaction,
	panelAddNewToStoreAction,
	panelWillUnMountTransaction
} from '../../../actions';
import * as commonActionTypes from '../../../actions/actionTypes';
import { WebInterfaceAction } from '../../../entities';
import components from '../../../panelComponents';
import IOpenDrawerPanelComponentPayload from '../entities/IOpenPanelComponentPayload';

export default function* openPanelComponent(payload: IOpenDrawerPanelComponentPayload) {
	try {
		if (payload.closePanelId) {
			//Kapatılacak paneller var ise kapatılacak panelleri kapat
			yield put(closeFlexPanelByIdTransactionAction(payload.closePanelId));
			yield put(panelWillUnMountTransaction({ panelId: payload.closePanelId }));
		}
		//İlgili container'ın chunk'ı yüklenmemişse yüklenmesini bekle
		yield waitContainerLoad(payload);

		const panelId = payload.id ?? createGuid();

		//Panel açılmış izlenimi için transaction başlat
		yield put(
			initializePanelManagerTransaction({
				panelId: panelId,
				panelType: payload.panelType,
				data: {
					parentPanel: payload.parentPanel,
					panelGuid: panelId,
					windowType: payload.type,
					...payload.props
				}
			})
		);

		//AddNewToStore parametresi eklenmişse ilgili actionları çalıştır. (openFlexPanel'dekinin aynısı)
		if (typeof payload.addNewToStore == 'boolean' && payload.addNewToStore) {
			yield put(
				panelAddNewToStoreAction({
					panelId: panelId,
					panelType: payload.panelType
				})
			);
		} else if (typeof payload.addNewToStore == 'object' && payload.addNewToStore.enable) {
			let panelData = payload.addNewToStore.panelData;
			if (payload.addNewToStore.setPanelDataPanelId && panelData.set) {
				panelData = panelData.set('panelId', panelId);
			}
			yield put(
				panelAddNewToStoreAction({
					panelId: panelId,
					panelType: payload.panelType,
					data: panelData
				})
			);
		}

		yield put(createMutableAction(ANIMATION_END_PANEL, { panel: { id: panelId } }));

		const drawerForm = openModalAction({
			type: 'DrawerPanelComponent',
			id: panelId,
			visible: true,
			width: payload.width ?? '50vw',
			props: {
				type: payload.type,
				actionRole: payload.actionRole,
				subProps: payload.props,
				modalId: panelId,
				title: payload.title,
				panelType: payload.panelType,
				parentPanel: payload.parentPanel,
				className: payload.className,
				maskClosable: payload.maskClosable
			}
		});
		yield put(drawerForm);

		yield spawn(listenCloseDrawer, panelId);

		return panelId;
	} catch (error) {
		console.error(error);
		return null;
	}
}

function* listenCloseDrawer(id: string) {
	yield take(
		(action: IBaseAction<WebInterfaceAction>) =>
			action.type == commonActionTypes.PANEL_WILL_UNMOUNT_TRANSACTION &&
			action.payload.panelId == id
	);
	yield put(closeModalTransactionAction(id));
}

function waitContainerLoad(payload: IOpenDrawerPanelComponentPayload) {
	return new Promise<void>(resolve => {
		const containerKey = MainUtils.GetComponentKeyFromPanelType(payload.panelType);
		const container = components[containerKey];

		if (typeof container?.onPanelOpening === 'function') {
			let args = undefined;

			if (payload.panelType === panelType.eBAApplicationForm) {
				args = {
					componentProps: [
						{
							props: {
								projectName:
									payload.props.projectName ||
									payload.props.childFormData?.projectName
							}
						}
					]
				};
			}

			container.onPanelOpening(args).then(() => {
				resolve();
			});
		} else {
			resolve();
		}
	});
}
